import { isEmpty } from 'lodash'
import { defaultExportMenu } from '../helpers'

export default ({ config, data, color }) => {
  const { dataFields, exportingMenu } = config
  const { value, name, children } = dataFields

  const configuration = {
    data: data,
    type: 'TreeMap',
    colors: {
      step: 2
    },
    dataFields: {
      value: value,
      name: name,
      children: children
    },
    seriesTemplates: {
      0: {
        columns: {
          fillOpacity: 0.8,
          stroke: '#fff',
          strokeWidth: 5,
          strokeOpacity: 1,
          tooltipText: ''
        },
        bullets: [
          {
            type: 'LabelBullet',
            locationY: 0.5,
            locationX: 0.5,
            label: {
              text: '{name} \n {value}',
              fill: '#fff'
            }
          }
        ]
      }
    }
  }

  // Export menu
  if (exportingMenu && exportingMenu.enabled) {
    if (isEmpty(exportingMenu.config)) {
      configuration.exporting = defaultExportMenu
    } else {
      configuration.exporting = exportingMenu.config
    }
  }

  return configuration
}
